import { useEffect, useState } from "react";

// App-wide light/dark choice, kept in this browser. The dark look is a CSS filter on <html> (see index.css), so every
// screen follows it without each page having its own dark colours.
const KEY = "app_theme";

export const getTheme = () => {
  try {
    return window.localStorage.getItem(KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("theme-dark", theme === "dark");
};

export const setTheme = (theme) => {
  try {
    window.localStorage.setItem(KEY, theme);
  } catch {
    /* private window: the choice lasts until the page is closed */
  }
  applyTheme(theme);
  window.dispatchEvent(new Event("app-theme-change"));
};

export function useTheme() {
  const [theme, setLocal] = useState(getTheme);
  useEffect(() => {
    const sync = () => setLocal(getTheme());
    window.addEventListener("app-theme-change", sync);
    return () => window.removeEventListener("app-theme-change", sync);
  }, []);
  return [theme, (t) => setTheme(t || (theme === "dark" ? "light" : "dark"))];
}
